import React, { PureComponent } from 'react';
import classnames from 'classnames';
import Avatar from 'housecall-ui/dist/DesignSystem/DataDisplay/Avatar/Avatar';
import makeStyles from 'housecall-ui/dist/DesignSystem/Styles/makeStyles';
import AvatarOld from 'material-ui/Avatar';

export default class ProAvatar extends PureComponent {
  render() {
    return this.props.useLatestMaterialUI ? <ProAvatarNew {...this.props} /> : <ProAvatarOld {...this.props} />;
  }
}

const useStyles = makeStyles(() => ({
  avatarInitials: ({ backgroundColor, fontSize }) => ({
    backgroundColor,
    fontSize,
  }),
}));

const ProAvatarNew = ({ size, initials, avatar, className, has_avatar, ...props }) => {
  const { avatarInitials } = useStyles(props);

  if (has_avatar) {
    return <Avatar width={size} className={classnames(className)} src={avatar} />;
  }
  return (
    <Avatar width={size} className={classnames(avatarInitials, className)}>
      {initials}
    </Avatar>
  );
};

const ProAvatarOld = (props) => {
  const size = props.size;

  if (props.has_avatar) {
    return <AvatarOld className={props.className} src={props.avatar} style={{ width: size, height: size }} />;
  }
  return (
    <AvatarOld
      className={props.className}
      style={{
        backgroundColor: props.backgroundColor,
        width: size,
        height: size,
        fontSize: props.fontSize,
      }}
    >
      {props.initials}
    </AvatarOld>
  );
};
